import { MergeDatasetData, MergeDatasetSource } from '../model';

export function getMergeDataset(target: MergeDatasetSource): MergeDatasetData {

    if (!target.__meta__) {
        target.__meta__ = {
            name: null,
            displayName: null,
            sources: []
        } as MergeDatasetData;
    }

    return target.__meta__;
}

export function getDataset(target: any): MergeDatasetData {
    return getMergeDataset(target.prototype);
}